import { Injectable } from "@angular/core";
import { ControllerBase } from "@fd/core";
import { Observable } from "rxjs";
import { EntityType } from "src/app/modules/shared/enums/entity-type.enum";
import { EntityInterface } from "src/app/modules/shared/models/common/entity.model";
import { ListItem } from "../../../models/common/list-item";
import { SupplierModel } from "src/app/modules/mrp/models/supplier.model";
import { FinishedGoodsComponentInterface } from "src/app/modules/change-management/models/finished-goods-component.model";

@Injectable({ providedIn: "root" })
export class EntityApiService extends ControllerBase<EntityInterface> {
  constructor() {
    super("Common/Entity");
  }

  //#region super implementation
  get(parentIds: number[], ...entityTypes: EntityType[]): Observable<EntityInterface[]> {
    return super._get<EntityInterface[]>({ query: { parentIds, entityTypes } });
  }

  getById(id: string): Observable<EntityInterface> {
    return super.$getById<EntityInterface>(id);
  }

  // post(model: EntityInterface) {
  //   return super.$post(model);
  // }

  // put(model: EntityInterface) {
  //   return super.$put(model);
  // }

  // delete(id: string) {
  //   return super.$delete(id);
  // }

  count(searchTerm: string, ...entityTypes: EntityType[]): Observable<number> {
    return super._count({ query: { searchTerm, entityTypes } });
  }
  //#endregion

  search(query: { searchTerm: string; top?: number }, ...entityTypes: EntityType[]): Observable<EntityInterface[]> {
    return super._getBySearch<EntityInterface[]>(query.searchTerm, { query: { entityTypes, top: query.top } });
  }

  getFinishedGoodsByComponent(id: number): Observable<FinishedGoodsComponentInterface[]> {
    return super._get<FinishedGoodsComponentInterface[]>({
      url: this.getFinishedGoodsByComponent.name,
      query: { id },
    });
  }

  exportFinishedGoodsByComponentReportCsv(id: number) {
    return this._downloadFile({
      url: this.exportFinishedGoodsByComponentReportCsv.name,
      query: { id },
    });
  }

  getCustomer(): Observable<ListItem[]> {
    return super._get<ListItem[]>({
      url: this.getCustomer.name,
    });
  }

  getSupplier(): Observable<SupplierModel[]> {
    return super._get<SupplierModel[]>({
      url: this.getSupplier.name,
    });
  }

  getCommodities(): Observable<ListItem[]> {
    return super._get<ListItem[]>({
      url: this.getCommodities.name,
    });
  }
}
